<script lang="ts" setup>
import { KpiStat } from '@forgd/ui-kit/blocks/kpi-stat'
import { ArrowUpRightIcon } from '@heroicons/vue/24/outline'

const props = defineProps<{
  loading?: boolean
  projectId: string
  projectTicker?: string | null
  isPublicPagePublished?: boolean
}>()

const { getTdUrl } = useTokenomicsUrl()

const publicPageUrl = computed(() => getTdUrl(props.projectId, props.projectTicker))

function handleAction() {
  window.open(publicPageUrl.value, '_blank', 'noopener,noreferrer')
}
</script>

<template>
  <KpiStat
    size="sm"
    :loading="loading"
    title="Public One-Pager"
    tooltip="This page contains all the project details added in Token Designer. Use this page to share your tokenomics with core contributors and investors."
    :value="isPublicPagePublished ? 'Live' : 'Draft'"
    :action="{ icon: ArrowUpRightIcon, label: 'Open Page' }"
    @action="handleAction"
  >
    <template #icon>
      <i :class="isPublicPagePublished ? 'i-lucide-globe-check' : 'i-lucide-globe-off'" class="size-4 text-primal" />
    </template>
    <template #description>
      <NuxtLink :href="publicPageUrl" target="_blank" class="truncate text-accent">
        {{ publicPageUrl }}
      </NuxtLink>
    </template>
  </KpiStat>
</template>
